import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { SERVER_URL } from "@/config/config";

export interface ChartData {
  labels: string[];
  gameBankSupply: (number | null)[];
  bulletSupply: (number | null)[];
  totalStakedTokens: (number | null)[];
  creditSpent: number[];
}

export interface MetricsState {
  chartData: ChartData;
  isLoadingChartData: boolean;
  error: string | null;
}

const initialState: MetricsState = {
  chartData: {
    labels: [],
    gameBankSupply: [],
    bulletSupply: [],
    totalStakedTokens: [],
    creditSpent: [],
  },
  isLoadingChartData: false,
  error: null,
};

// Get chart data from /metrics/chart API
export const getChartDataAction = createAsyncThunk(
  "metrics/getChartDataAction",
  async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/metrics/chart`);
      return response.data.data;
    } catch (error) {
      throw new Error("Failed to fetch chart data");
    }
  }
);

export const metricsSlice = createSlice({
  name: "metrics",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getChartDataAction.pending, (state) => {
        state.isLoadingChartData = true;
        state.error = null;
      })
      .addCase(getChartDataAction.fulfilled, (state, { payload }) => {
        state.isLoadingChartData = false;
        state.chartData = payload;
      })
      .addCase(getChartDataAction.rejected, (state, { error }) => {
        state.isLoadingChartData = false;
        state.error = error.message || "Failed to fetch chart data";
      });
  },
});

export const { clearError } = metricsSlice.actions;
export default metricsSlice.reducer; 